import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UserModel} from '../../../../services/models/user-model';
import {CoachSessionModel} from '../../../coach/models/session.model';
import {VideoChatService} from '../../service/video-chat.service';
import {CoachSessionChatModel} from '../../models/session-chat.model';
import {UserInfoModel} from "../../../../services/models/user-info.model";

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {

    @Input() currentSession: CoachSessionModel;
    @Input() user: UserModel;
    @Input() userInfo: UserInfoModel;

    @Output() onClose: EventEmitter<any> = new EventEmitter();

    message: string;
    messageList: CoachSessionChatModel[] = [];
    messageListPromise: Promise<CoachSessionChatModel[]>;
    messageListValid = false;

    updateEvent: any;
    userType: string = "delegate";
    constructor(private videoChat: VideoChatService) {
    }

    ngOnInit() {
        this.updateMessageList();
        this.userType = this.userInfo.id === this.currentSession.coach.id ? "coach" : "delegate";
    }

    updateMessageList() {
        clearTimeout(this.updateEvent);

        this.videoChat.getCoachSessionChat(this.currentSession.id, this.messageList.length)
            .then((data) => {
                if (data.length) {
                    this.messageList = this.messageList.concat(data);
                    this.scrollToBottom();
                }
                this.messageListValid = true;
                this.updateEvent = setTimeout(() => this.updateMessageList(), 10000);
            });
    }

    sendMessage(): void {
        if (this.user && this.message) {
            this.message = this.message.replace(/ +(?= )/g, '');
            if (this.message !== '' && this.message !== ' ') {
                this.videoChat.addCoachSessionChat(this.currentSession.id, this.message)
                    .then((data) => {
                        this.message = '';
                        this.updateMessageList();
                    });
            }
        }
    }

    eventKeyPress(event) {
        if (event && event.keyCode === 13) {
            this.sendMessage();
        }
    }

    scrollToBottom(): void {
        setTimeout(() => {
            try {
                const contentMessages = document.getElementsByClassName('message-wrap');
                Array.prototype.forEach.call(contentMessages, (contentMessage) => {
                    contentMessage.scrollTop = contentMessage.scrollHeight;
                });
            } catch (err) {
                console.error(err);
            }
        }, 20);
    }

    onFocus() {
    }

    dismiss() {
        this.onClose.emit(false);
    }

    ngOnDestroy() {
        clearTimeout(this.updateEvent);
    }
}
